"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
let ProjectAssociation = class ProjectAssociation extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.definedProject = [];
        this.proposalName = '';
        this.selectedTemplate = null;
        this.unit = null; // {label: 'acres', value: 'acres'};
        //    optionUnits = ['acres','hectares'];
        this.optionUnits = [
            { label: 'acres', value: 'acres' },
            { label: 'hectares', value: 'hectares' },
        ];
    }
    get enableButton() {
        //return true;
        return this.unit && !!this.unit.value && this.selectedTemplate && !!this.selectedTemplate.value;
    }
    getTemplateCaption(template) {
        var _a;
        return (_a = this.projectList.find(p => p.value === template).label) !== null && _a !== void 0 ? _a : '-';
    }
    addProject() {
        let project = {
            unit: this.unit.value,
            template: this.selectedTemplate.value,
            proposalName: this.proposalName
        };
        this.proposalName = '';
        this.unit = null; //{label: null, value: null};
        this.selectedTemplate = null; //{value: null, label: null};
        this.definedProject.push(project);
    }
    changeUnitCriteria(criteria) {
        // console.log({criteria})
        // this.unit = criteria
        console.log({ unit: criteria });
    }
    changeTemplateCriteria(criteria) {
        // console.log({criteria})
        // this.selectedTemplate = criteria
        console.log({ selectedTemplate: criteria });
    }
    deleteProject(index) {
        console.log({ index });
        this.definedProject.splice(index, 1);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProjectAssociation.prototype, "projectList", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProjectAssociation.prototype, "definedProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('unit'),
    (0, vue_property_decorator_1.Watch)('selectedTemplate')
], ProjectAssociation.prototype, "enableButton", null);
ProjectAssociation = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            FullsizeTemplate: bmk_ui_framework_1.FullsizeTemplate,
            Modal: bmk_ui_framework_1.Modal,
            Inbox: lucide_vue_next_1.Inbox,
            Button: bmk_ui_framework_1.Button,
            ArrowLeft: lucide_vue_next_1.ArrowLeft, SelectV2: bmk_ui_framework_1.SelectV2
        }
    })
], ProjectAssociation);
exports.default = ProjectAssociation;
